import React, { Fragment, useContext, useEffect, useState } from "react";
import { postMethod } from "../../requests";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { Button, Col, Container, Form, InputGroup, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faSpinner, faUserEdit } from "@fortawesome/free-solid-svg-icons";
import { faCalendar, faUser } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";

const UserLogs = () => {
    const { t } = useTranslation();
    const [list, setList] = useState([]);
    const { checkServerData, changeView } = useContext(BasicContext);
    const [displayNOR, setDisplayNOR] = useState(null);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);

    const limit = 20;

    const getLogs = async () => {
        const res = await postMethod("/user-logs", { page: displayNOR, limit: limit });
        if (checkServerData(res)) {
            let _list = list,
                getList = res.data.list;
            //console.log(getList[getList.length - 1].user_log_id, displayNOR);
            if (getList[getList.length - 1].user_log_id !== displayNOR && displayNOR) setDisplayNOR(getList[getList.length - 1].user_log_id);
            if (getList.length < limit) setDisableBtn(true);
            _list = _list.concat(getList);
            setList(_list);
        }
    };

    const getLogsSearch = async () => {
        const res = await postMethod("/user-logs-search", { search: search });
        if (checkServerData(res)) {
            setList(res.data.list);
        }
    };

    useEffect(() => {
        getLogs();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (list.length === 0) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 mt-4 mb-2 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("userLogs.logs")}</h1>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 my-3 px-lg-2 ">
                                <InputGroup className="mb-3">
                                    <Form.Control placeholder={t("typePhrase")} aria-label="search-label" aria-describedby="search-input" value={search} onChange={(v) => setSearch(v.target.value)} />
                                    <Button
                                        variant="outline-secondary"
                                        disabled={search.length === 0}
                                        onClick={() => {
                                            setSearch("");
                                            getLogs();
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEraser} />
                                    </Button>
                                    <Button variant="outline-primary" id="search-input" onClick={() => getLogsSearch()} disabled={search.length === 0}>
                                        {t("search")}
                                    </Button>
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table" size="sm">
                                            <tbody>
                                                {list.map((e, i) => (
                                                    <Fragment key={i}>
                                                        <tr>
                                                            <td rowSpan={e.user_id ? 3 : 2}>{i + 1}.</td>
                                                            <td className="border-0 mb-1 text-start">
                                                                <FontAwesomeIcon icon={faCalendar} className="me-1" />
                                                                {moment(e.user_log_date).format("DD.MM.YYYY HH:mm:ss")}
                                                            </td>
                                                            <td rowSpan={e.user_id ? 3 : 2} style={{ width: "55%" }} className="text-start">
                                                                {e.user_log_desc}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={e.user_id ? "border-0 mb-1 text-start" : "text-start"}>
                                                                <Button
                                                                    variant="link"
                                                                    size="sm"
                                                                    onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: e.create_user_id } })}
                                                                    className="p-0 text-start"
                                                                >
                                                                    <FontAwesomeIcon icon={faUser} className="me-1" />
                                                                    {e.creator_name} {e.creator_surname}
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                        {e.user_id && (
                                                            <tr>
                                                                <td className="text-start">
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: e.user_id } })}
                                                                        className="p-0 text-start"
                                                                    >
                                                                        <FontAwesomeIcon icon={faUserEdit} className="me-1" />
                                                                        {e.user_name} {e.user_surname}
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Fragment>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>

                                    <Col xs={12} className="text-center">
                                        {disableBtn ? (
                                            <p className="opacity-4 my-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            !search && (
                                                <Button onClick={() => getLogs()} variant="outline-primary" className="my-3">
                                                    {t("loadMore")}
                                                </Button>
                                            )
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default UserLogs;
